import { render, staticRenderFns } from "./CreateModuleForm.vue?vue&type=template&id=3e796e14"
import script from "./CreateModuleForm.vue?vue&type=script&lang=js"
export * from "./CreateModuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports